<template>
    <div class="sidebar-container">
        <div class="sidebar">
            <nav class="navys flex-column justify-content-between">
                <div class="nav-top">
                    <router-link class="navys-link" :to="{ name: 'accueil' }"
                        :class="{ 'active': this.$route.name === 'accueil' }" data-bs-toggle="tooltip"
                        data-bs-placement="right" title="Accueil">
                        <img src="@/assets/icons/Home/home.svg" alt="icone">
                    </router-link>
                    <router-link class="navys-link" :to="{ name: 'vehicules' }"
                        :class="{ 'active': (this.$route.name === 'vehicules') || (this.$route.name === 'interventions') }"
                        data-bs-toggle="tooltip" data-bs-placement="right" title="Parc Automobile">
                        <img src="@/assets/parc.png" alt="icone">
                    </router-link>
                    <router-link class="navys-link" :to="{ name: 'utilisateurs' }"
                        :class="{ 'active': this.$route.name === 'utilisateurs' }" data-bs-toggle="tooltip"
                        data-bs-placement="right" title="Ressources Humaines">
                        <img src="@/assets/rh.png" alt="icone">
                    </router-link>
                    <router-link class="navys-link" :to="{ name: 'courses' }"
                        :class="{ 'active': (this.$route.name === 'courses') || (this.$route.name === 'demandes') || (this.$route.name === 'programmes') || (this.$route.name === 'paiements') }"
                        data-bs-toggle="tooltip" data-bs-placement="right" title="Operations">
                        <img src="@/assets/icons/Operations.svg" alt="icone">
                    </router-link>
                    <router-link class="navys-link" :to="{ name: 'factures' }"
                        :class="{ 'active': (this.$route.name === 'factures') || (this.$route.name === 'pieces_de_caisse') || (this.$route.name === 'journaux') || (this.$route.name === 'achats') }"
                        data-bs-toggle="tooltip" data-bs-placement="right" title="Comptabilité">
                        <img src="@/assets/icons/Compta.svg" alt="icone">
                    </router-link>
                    <router-link class="navys-link" :to="{ name: 'geolocalisation' }"
                        :class="{ 'active': this.$route.name === 'geolocalisation' }" data-bs-toggle="tooltip"
                        data-bs-placement="right" title="Geolocalisation">
                        <img src="@/assets/icons/Geolocalisation.svg" alt="icone">
                    </router-link>
                    <router-link class="navys-link" :to="{ name: 'tableau-de-bord' }"
                        :class="{ 'active': this.$route.name === 'tableau-de-bord' }" data-bs-toggle="tooltip"
                        data-bs-placement="right" title="Tableau de bord">
                        <img src="@/assets/tab.png" alt="icone">
                    </router-link>
                    <router-link class="navys-link" :to="{ name: 'configurations' }"
                        :class="{ 'active': (this.$route.name === 'configurations') || (this.$route.name === 'configurations.general') || (this.$route.name === 'configurations.courses') || (this.$route.name === 'configurations.interventions') || (this.$route.name === 'configurations.vehicules') }"
                        data-bs-toggle="tooltip" data-bs-placement="right" title="Configurations">
                        <img src="@/assets/icons/Parametres.svg" alt="icone">
                    </router-link>
                </div>

                <div class="nav-bottom mt-auto">
                    <button class="navys-link action-btn position-relative mobile-only-notification"
                        @click="openNotificationsModal()" data-bs-toggle="tooltip" data-bs-placement="right"
                        title="Notifications">
                        <i class="far fa-bell"></i>
                        <span v-if="notificationCount > 0" class="compteur badge badge-danger position-absolute">
                            {{ notificationCount }}
                        </span>
                    </button>
                </div>
            </nav>
        </div>
    </div>
</template>

<script>
import { defineComponent, defineAsyncComponent } from 'vue';
import { mapGetters } from 'vuex';
const NotificationComponent = defineAsyncComponent(() => import('@/components/NotificationComponent.vue'));
const MessageComponent = defineAsyncComponent(() => import('@/components/MessageComponent.vue'));
const MyProfile = defineAsyncComponent(() => import('@/auth/MyProfile.vue'));

export default defineComponent({
    name: 'SideBar',
    data() {
        return {
            isFullscreen: false
        }
    },
    computed: {
        ...mapGetters(['notificationCount', 'messageCount'])
    },
    methods: {
        openNotificationsModal() {
            this.$dialog.open(NotificationComponent, {
                props: {
                    header: "Notifications",
                    style: {
                        width: '50vw'
                    },
                    modal: true
                },
            });
        },
        openMessagesModal() {
            this.$dialog.open(MessageComponent, {
                props: {
                    header: "Messages",
                    style: {
                        width: '50vw'
                    },
                    modal: true
                },
            });
        },
        openProfileModal() {
            this.$dialog.open(MyProfile, {
                props: {
                    header: "Mon compte",
                    style: {
                        width: '40vw'
                    },
                    modal: true
                },
            });
        }
    }
})
</script>

<style scoped>
.sidebar-container {
    height: 100%;
}

.sidebar {
    height: 100%;
}

.navys {
    height: 100%;
    display: flex;
}

.nav-top {
    display: flex;
    flex-direction: column;
}

.nav-bottom {
    display: flex;
    flex-direction: column;
    position: relative;
    bottom: 80px;
}

.action-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background: none;
    border: none;
    color: inherit;
}

.compteur {
    top: 0;
    right: 0;
    font-size: 0.6rem;
    transform: translate(30%, -30%);
}

/* Hide notification button by default */
.mobile-only-notification {
    display: none;
}

/* Only show notification button on screens less than 992px wide */
@media (max-width: 992px) {
    .mobile-only-notification {
        display: flex;
    }
}
</style>